import { render } from "./ResultStatCorrectness.vue?vue&type=template&id=18726538&scoped=true"
import script from "./ResultStatCorrectness.vue?vue&type=script&lang=js"
export * from "./ResultStatCorrectness.vue?vue&type=script&lang=js"

import "@/css/components/c-result-stat-correctness.css?vue&type=style&index=0&id=18726538&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18726538"]])

export default __exports__